export default {"src":"/_next/static/media/strategic.c3507a9c.svg","height":26,"width":21};